var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"default-layout"}},[(_vm.loaded)?[_c('TopNav'),_c('RouterView',{key:_vm.$route.fullPath,staticClass:"app-view"}),_c('AppFooter'),(_vm.$panel.visible)?_c('AppPanel'):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }